import { render, staticRenderFns } from "./addPropertyEnterprisePeopleInfo.vue?vue&type=template&id=25a5a365&"
import script from "./addPropertyEnterprisePeopleInfo.vue?vue&type=script&lang=js&"
export * from "./addPropertyEnterprisePeopleInfo.vue?vue&type=script&lang=js&"
import style0 from "./addPropertyEnterprisePeopleInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports